import * as Sentry from "@sentry/browser";
import { TokenList } from "../store/global/getAllTokenLists";
import { Amount } from "../types/amount";
import { Hash } from "viem";
import { TokenListMetadata } from "../hooks/queries/tokens-queries";

export const transformPricesToBalances = (tokenList: TokenList) => {
  return Object.keys(tokenList).map(token => {
    return {
      tokenAddress: token as Hash,
      balance: Amount.ZERO,
    };
  });
};
export const getPriceForTokenByTokenList = (
  tokenAddress?: Hash,
  tokenList?: TokenList,
  tokenListMetadata?: TokenListMetadata
): Amount => {
  if (tokenList && tokenAddress) {
    const tokenEntry = tokenList[tokenAddress];
    if (tokenEntry) {
      return tokenEntry.priceUsd;
    }
  }
  if (tokenListMetadata && tokenAddress) {
    const tokenEntry = tokenListMetadata[tokenAddress];
    if (tokenEntry) {
      return new Amount(tokenEntry.p?.toString() ?? "0");
    }
  }
  return Amount.ZERO;
};

export const getNameForToken = (tokenAddress?: Hash, tokenList?: TokenList) => {
  if (tokenList && tokenAddress) {
    const name = tokenList[tokenAddress]?.name;
    if (name) {
      return name;
    } else {
      Sentry.captureException(`Could not find a name from metadata for ${tokenAddress}`);
    }
  }
  Sentry.captureException(`No metadata available. Returning hardcoded name for ${tokenAddress}`);
  return "???";
};
export const getSymbolForToken = (tokenAddress?: Hash, tokenList?: TokenList) => {
  if (tokenList && tokenAddress) {
    const symbol = tokenList[tokenAddress]?.ticker;
    if (symbol) {
      return symbol;
    } else {
      Sentry.captureException(`Could not find a ticker from metadata for ${tokenAddress}`);
    }
  }
  Sentry.captureException(`No metadata available. Returning hardcoded name for ${tokenAddress}`);
  return "???";
};
export const getColourForToken = (
  tokenAddress: Hash,
  tokenList?: TokenList
): string | undefined => {
  if (tokenList) {
    const colour = tokenList[tokenAddress]?.colour;
    if (colour) {
      return colour;
    } else {
      Sentry.captureException(`Could not find a colour from metadata for ${tokenAddress}`);
    }
  }
};
